import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import nodatauser from '../../../assets/images/nodatauser.svg'

const NoAnalyticReportFound = () => {

    return (
        <>
            <div className='container-fluid nodatafound'>
                <div className="row justify-content-center mt-3">
                    <div className="col-md-6">
                        <img src={nodatauser} style={{ maxWidth: '60%' }} alt="" />
                        <h5 className='mb-0' style={{ fontSize: '20px' }}>No analytics data found for <br /> this module </h5>
                        {/* <p>Play the module first to view and track your progress. </p> */}
                        {/* <button className='DefaultRedBtn' onClick={() => navigate("/")}>Start Module</button> */}
                    </div>
                </div>
            </div>
            {/* 
            <div className=" text-center mt-3">
                <LottiePlayer
                    animationData={analyticreport}
                    style={{ height: 200 }}
                    autoplay
                    loop
                />
                <h4 className='mt-1'>No Analytic Report Found</h4>
            </div> */}

        </>
    )
}

export default NoAnalyticReportFound
